// Kısa iki tonlu uyarı sesi (WebAudio — dosya gerektirmez). "ge_mute" ayarına uyar.
let _ctx = null;
export const playNotifySound = () => {
  if (localStorage.getItem("ge_mute") === "1") return;
  try {
    if (!_ctx) _ctx = new (window.AudioContext || window.webkitAudioContext)();
    const ctx = _ctx;
    if (ctx.state === "suspended") ctx.resume();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain); gain.connect(ctx.destination);
    osc.type = "sine";
    osc.frequency.setValueAtTime(880, ctx.currentTime);
    osc.frequency.setValueAtTime(1245, ctx.currentTime + 0.12);
    gain.gain.setValueAtTime(0.001, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.25, ctx.currentTime + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.35);
    osc.start(); osc.stop(ctx.currentTime + 0.36);
  } catch { /* ses desteklenmiyor */ }
};

const tones = (seq, type, vol) => {
  if (localStorage.getItem("ge_mute") === "1") return;
  try {
    if (!_ctx) _ctx = new (window.AudioContext || window.webkitAudioContext)();
    const ctx = _ctx;
    if (ctx.state === "suspended") ctx.resume();
    seq.forEach(([freq, at, dur]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain); gain.connect(ctx.destination);
      osc.type = type;
      const t0 = ctx.currentTime + at;
      osc.frequency.setValueAtTime(freq, t0);
      gain.gain.setValueAtTime(0.001, t0);
      gain.gain.exponentialRampToValueAtTime(vol, t0 + 0.015);
      gain.gain.setValueAtTime(vol, t0 + dur * 0.7);
      gain.gain.exponentialRampToValueAtTime(0.001, t0 + dur);
      osc.start(t0); osc.stop(t0 + dur + 0.02);
    });
  } catch { /* ses desteklenmiyor */ }
};
// Belirgin alarm (depo tableti — canlı sepet değişti): 3 kez iki tonlu kesik uyarı
export const playAlertSound = () => tones([0, 0.42, 0.84].flatMap((s) => [[988, s, 0.17], [1319, s + 0.19, 0.17]]), "square", 0.22);
// Yumuşak "hazır" çanı (sepet — depo kalemi hazırladı)
export const playReadySound = () => tones([[784, 0, 0.16], [988, 0.12, 0.16], [1175, 0.24, 0.3]], "sine", 0.2);
